import { render, staticRenderFns } from "./my-profile-dialog.component.vue?vue&type=template&id=33ff5eec"
import script from "./my-profile-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./my-profile-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ff5eec')) {
      api.createRecord('33ff5eec', component.options)
    } else {
      api.reload('33ff5eec', component.options)
    }
    module.hot.accept("./my-profile-dialog.component.vue?vue&type=template&id=33ff5eec", function () {
      api.rerender('33ff5eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/my-profile-dialog/my-profile-dialog.component.vue"
export default component.exports